import { collection, getDocs, limit as limitTo, orderBy, query } from 'firebase/firestore';
import { db } from '../../config';
import { VerificationTrace } from '../../../../types/verificationTrace';

export type OcrExecutionRecord = {
  id: string;
  execution_type: string;
  target_item_ids: string[] | null;
  used_azure_cache: boolean;
  token_usage: Record<string, unknown>;
  result_data: Record<string, unknown>;
  executed_at: Date;
  executed_by: string;
  executed_by_name: string;
  is_proxy?: boolean;
  pattern_history_id?: string | null; // 実行時に使用された pattern_history のID
  // 検証トレース（#3109）。運営スタッフの検証実行時のみ設定される。
  verification_trace?: VerificationTrace | null;
};

/**
 * OCR実行履歴を取得（実行日時の降順）
 *
 * 1件あたり result_data 全量を持つため、比較の基準を決めるだけなら
 * 全件読む必要はない。maxCount を渡すと降順の先頭からその件数だけ読む（#3318）。
 */
export const getOcrExecutions = async (
  resultId: string,
  maxCount?: number,
): Promise<OcrExecutionRecord[]> => {
  const executionsRef = collection(db, 'results', resultId, 'ocr_executions');
  const q =
    maxCount === undefined
      ? query(executionsRef, orderBy('executed_at', 'desc'))
      : query(executionsRef, orderBy('executed_at', 'desc'), limitTo(maxCount));
  const snapshot = await getDocs(q);

  return snapshot.docs.map(doc => {
    const data = doc.data();
    return {
      id: doc.id,
      execution_type: data.execution_type,
      target_item_ids: data.target_item_ids || null,
      used_azure_cache: data.used_azure_cache ?? false,
      token_usage: data.token_usage || {},
      result_data: data.result_data || {},
      executed_at: data.executed_at?.toDate?.() ?? new Date(),
      executed_by: data.executed_by || '',
      executed_by_name: data.executed_by_name || '',
      is_proxy: data.is_proxy || false,
      pattern_history_id: (data.pattern_history_id as string | null | undefined) ?? null,
      verification_trace: (data.verification_trace as VerificationTrace | null | undefined) ?? null,
    };
  });
};
